import React, { Component } from 'react';
/* eslint-disable */

import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import language from '../../../../assets/languages/language';
import ValidateSaveReportIcon from '../../../Common/ValidateSaveReportIcon';
import StarRatings from 'react-star-ratings';
import AppRoutes from '../../../config/AppRoutes';
import Loader from '../../../../common/loader';
import GMATCalculator from '../../../../common/Calculator/GMATCalculator';
import { renderHTMLContent } from '../../../../common/function';
var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
class GMATTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      data: '',
      question: '',
      statement1: '',
      statement2: '',
      statement3: '',
      statement4: '',
      statement5: '',
      choice1: '',
      choice2: '',
      choice3: '',
      choice4: '',
      choice5: '',
      choice_a: 'Yes',
      choice_b: 'No',
      explanation: '',
      token: '',
      idname: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      save_text: `${language.LC().SAVE_QUESTION}`,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      text_color: 'card-header',
      result: '',
      reportLoading: false,
      chapter_id: this.props.params.chapterid,
      reading_id: this.props.params.readingid,
      subscriptionstatus: this.props.params.subscription ? 'paid' : 'free',
      reading: this.props.params.reading,
      offset: this.props.params.offset,
      questionsArray: [],
      display_loader: 'show_block',
      questionHide: 'hide_block',
      choice1_yes: '',
      choice2_yes: '',
      choice3_yes: '',
      choice4_yes: '',
      choice5_yes: '',
      choice1_no: '',
      choice2_no: '',
      choice3_no: '',
      choice4_no: '',
      choice5_no: '',
      answer1: '',
      answer2: '',
      answer3: '',
      answer4: '',
      answer5: '',
      error: '',
      quiz_id: this.props.params.quiz_id,
      offset: this.props.params.offset ? parseInt(this.props.params.offset) : 0,
      all_reading_type: '',
      count: this.props.params.timer ? this.props.params.timer : 0,
      display_question: '',
      timerstopbtn: 'icon-control-pause pause_btn',
    };
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };
  componentDidMount() {
    this.mounted = true;
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (this.mounted) {
      this.setState({
        idname: storage_session['idname'],
      });
      this.setState({
        token: storage_session['token'],
      });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      quiz_id: this.state.quiz_id,
    };
    //Api to fetch Quiz by quiz id
    FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuize', data).then(resp => {
      if (resp.success) {
        var retun_all_question = JSON.stringify(resp.singlequiz);
        var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
        let readings = JSON.parse(JSON.parse(retun_all_question)).readings;
        var question_id = [];
        var reading_id = [];
        for (var i = 0; i < resp.questions_count; i++) {
          question_id.push(all_questions[i]);
          reading_id.push(readings[i]);
        }
        var timer_value = resp.timer_value;

        var first_question_id = question_id[this.state.offset];
        var first_reading_type = reading_id[this.state.offset];
        var user_timer = resp.user_time_value;
        this.setState({
          user_time_value: user_timer,
          count: resp.user_time_value ? resp.user_time_value : parseInt(this.props.params.timer),
          count_temp: user_timer,
        });
        this.setState({
          all_question_id: question_id,
          question_length: question_id.length,
          timer_value: timer_value,
          include_timer: resp.include_timer,
          first_question_id: first_question_id,
          first_reading_type: first_reading_type,
          all_reading_type: reading_id,
        });

        if (question_id.length - 1 == this.state.offset) {
          this.setState({
            next_block: 'card hide_block',
          });
        }

        var data = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: first_question_id,
          type: first_reading_type,
        };
        //Api to fetch question by question id
        FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(resp => {
          if (resp.success) {
            var data_check = {
              token: this.state.token,
              idname: this.state.idname,
              quiz_id: this.state.quiz_id,
              question_id: first_question_id,
              type: first_reading_type,
            };
            this.setQuestionData(resp.questionsbyid);
            /*Api to fetch question and check answered */
            FD.callAPI(App_data.backend_api + '/gmat_quizes/checkAnswered', data_check).then(
              resp_inner => {
                this.setState({
                  already_answered_status: resp_inner.message,
                });
              },
            );
            this.setState({
              ValidToken: true,
            });
            this.setState({
              display_question: resp.questionsbyid,
            });
            this.setState({
              display_loader: 'hide_block',
            });
            var params = {
              token: this.state.token,
              question_id: first_question_id,
              idname: this.state.idname,
              type: first_reading_type,
            };
            /*Api to fetch Saved question */
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params).then(
              response => {
                if (response.success) {
                  this.setState({
                    save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                  });
                  this.setState({
                    bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                  });
                  this.setState({
                    bookmarkColor: 'rgb(54, 141, 84)',
                  });
                  this.setState({
                    save_text: `${language.LC().Question_Saved}`,
                  });
                }
              },
            );
            var params = {
              token: this.state.token,
              idname: this.state.idname,
              quiz_id: this.state.quiz_id,
              question_id: first_question_id,
            };
            /*Api to fetch commented on question*/
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
              response => {
                if (response.success) {
                  var comments = '';
                  this.setState({
                    ValidToken: true,
                  });
                  if (response.comments.length > 0) {
                    comments = response.comments.map((items, index) => (
                      <li key={index}>
                        {response.user_id == items.uid ? (
                          <ul className='icon_list'>
                            <li>
                              <a
                                className='pointer_class'
                                onClick={this._editComment.bind(this, items)}
                              >
                                <i className='fa fa-pencil' />
                              </a>
                            </li>
                            <li>
                              <a
                                className='pointer_class'
                                onClick={this._deleteComment.bind(this, items)}
                              >
                                <i className='fa fa-close' />
                              </a>
                            </li>
                          </ul>
                        ) : (
                          <ul />
                        )}

                        <h4>
                          {language.LC().BY} {items.username},{' '}
                          {new Date(items.createdAt).toDateString()}
                        </h4>
                        <p>{items.comment}</p>
                      </li>
                    ));

                    this.setState({
                      comment_data: comments,
                    });
                  } else {
                    comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                    this.setState({
                      comment_data: comments,
                    });
                  }
                } else {
                  comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                  this.setState({
                    comment_data: comments,
                  });
                  this.setState({
                    ValidToken: false,
                  });
                }
                return response;
              },
            );
          } else {
            // console.log(resp.success + '------------failure');
          }
        });

        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: first_question_id,
          quiz_id: this.state.quiz_id,
        };
        /*Api to fetch flash card*/
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = '';
            if (response.success) {
              this.setState({
                ValidToken: true,
              });
              if (response.flash_cards.length > 0) {
                this.setState({
                  flash_form: 'col-sm-12 col-md-12 hide_block',
                });
                flash_cards = response.flash_cards.map(items => (
                  //alert(items.id)
                  <li>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({
                  flash_form: 'col-md-12 display_block',
                });
                flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({
                flash_data: flash_cards,
              });
            } else {
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({
                ValidToken: false,
              });
              this.setState({
                flash_data: flash_cards,
              });
              this.setState({
                flash_form: 'col-md-12 display_block',
              });
            }
            return response;
          },
        );
      } else {
        // console.log(resp.success + '------------failure');
      }
      return resp;
    });
    clearInterval(this.timer);
    this.timer = setInterval(this.tick.bind(this), 1000);
  }
  //Function to change time every second and store in database
  tick() {
    if (this.state.count != 0) {
      var count_value = this.state.count;
      var insert_time = {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        user_time_value: count_value,
      };
      // console.log("user time",this.state.user_time_value)
      FD.callAPI(App_data.backend_api + '/gmat_quizes/insertTimer', insert_time).then(resp => {
        if (resp.success) {
          // console.log('Timer Update Successfull');
        } else {
          // console.log('Fail Timer Update');
        }
      });
      this.setState({ count: this.state.count - 1 });
      this.setState({ timer_display: 'card-block' });
    } else {
      this.context.router.push({
        pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(
          ':quiz_id',
          this.state.quiz_id,
        ).replace(':status_send', 'completed'),
      });
    }
    // if (this.state.timer_value === this.state.count) {
    //   // this.setState({count_end_message:'Time&#8242;s Up'});
    //   this.setState({ timer_display: 'card hide_block' });
    // }
  }
  getFavQuestions = questionid => {
    var params_fav = {
      token: this.state.token,
      question_id: questionid,
      idname: this.state.idname,
      chapter_id: this.props.params.chapterid,
      type: 'tab_question',
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(
      response => {
        if (response.success) {
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        }
      },
    );
  };

  getGMATRatting = questionid => {
    var params = {
      token: this.state.token,
      question_id: questionid,
      idname: this.state.idname,
      type: 'tab_question',
    };
    //Api to get ratting
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
      response => {
        if (response.success) {
          this.setState({ rated: true });
          response.ratting.map(items =>
            this.setState({
              rating: items.ratting,
              ratting_text: 'Rated ',
            }),
          );
        }
      },
    );
  };

  openCity = (evt, cityName) => {
    let i;
    let tabcontent;
    let tablinks;
    tabcontent = document.getElementsByClassName('tabcontent');
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none';
    }
    tablinks = document.getElementsByClassName('tablinks');
    for (i = 0; i < tablinks.length; i++) {
      let value = tablinks[i].value;
      if (value === cityName) {
        tablinks[i].className += ' active';
      } else {
        tablinks[i].classList.remove('active');
      }
      // tablinks[i].className = tablinks[i].className.replace(' active', '');
    }
    document.getElementById(cityName).style.display = 'block';
    // evt.currentTarget.className += ' active';
  };

  clickHandler = e => {
    this.openCity(e, e.target.value.trim());
  };

  setRadioButtonCorrectChoice = value => {
    let resetRadioButton = document.getElementsByName('correct_choice');
    for (var i = 0; i < resetRadioButton.length; i++) resetRadioButton[i].checked = value;
  };
  /*
  ------------------------------------------------------------------------------
    Function to show Correct box and display right answer and store in database
  -------------------------------------------------------------------------------
    */
  _getResult = async (item, e) => {
    let {
      choice1,
      choice2,
      choice3,
      choice4,
      choice5,
      answer1,
      answer2,
      answer3,
      answer4,
      answer5,
    } = this.state;
    let expectedCount = 3;
    if (this.state.statement3 === '') {
      expectedCount = 2;
    }
    let count = 0;
    let activateExplanation = true;
    if (answer4 !== '' && answer5 !== '') {
      activateExplanation = false;
      if ((choice4 !== '', choice5 !== '')) {
        activateExplanation = true;
      }
      expectedCount = 5;
      if (choice4.toLowerCase().trim() === answer4.toLowerCase().trim()) {
        count++;
        if (choice4.toLowerCase().trim() === 'yes') {
          this.setState({
            choice4_yes: 'accent-success',
          });
        } else {
          this.setState({
            choice4_no: 'accent-success',
          });
        }
      } else {
        if (choice4.toLowerCase().trim() === 'yes') {
          this.setState({
            choice4_yes: 'accent-faliure',
          });
        } else {
          this.setState({
            choice4_no: 'accent-faliure',
          });
        }
      }
      if (choice5.toLowerCase().trim() === answer5.toLowerCase().trim()) {
        count++;
        if (choice5.toLowerCase().trim() === 'yes') {
          this.setState({
            choice5_yes: 'accent-success',
          });
        } else {
          this.setState({
            choice5_no: 'accent-success',
          });
        }
      } else {
        if (choice5.toLowerCase().trim() === 'yes') {
          this.setState({
            choice5_yes: 'accent-faliure',
          });
        } else {
          this.setState({
            choice5_no: 'accent-faliure',
          });
        }
      }
    }
    if (choice1 && choice2 && (choice3 || this.state.statement3 === '')) {
      if (choice1.toLowerCase().trim() === answer1.toLowerCase().trim()) {
        count++;
        if (choice1.toLowerCase().trim() === 'yes') {
          this.setState({
            choice1_yes: 'accent-success',
          });
        } else {
          this.setState({
            choice1_no: 'accent-success',
          });
        }
      } else {
        if (choice1.toLowerCase().trim() === 'yes') {
          this.setState({
            choice1_yes: 'accent-faliure',
          });
        } else {
          this.setState({
            choice1_no: 'accent-faliure',
          });
        }
      }
      if (choice2.toLowerCase().trim() === answer2.toLowerCase().trim()) {
        count++;
        if (choice2.toLowerCase().trim() === 'yes') {
          this.setState({
            choice2_yes: 'accent-success',
          });
        } else {
          this.setState({
            choice2_no: 'accent-success',
          });
        }
      } else {
        if (choice2.toLowerCase().trim() === 'yes') {
          this.setState({
            choice2_yes: 'accent-faliure',
          });
        } else {
          this.setState({
            choice2_no: 'accent-faliure',
          });
        }
      }
      if (choice3.toLowerCase().trim() === answer3.toLowerCase().trim()) {
        count++;
        if (choice3.toLowerCase().trim() === 'yes') {
          this.setState({
            choice3_yes: 'accent-success',
          });
        } else {
          this.setState({
            choice3_no: 'accent-success',
          });
        }
      } else {
        if (choice3.toLowerCase().trim() === 'yes') {
          this.setState({
            choice3_yes: 'accent-faliure',
          });
        } else {
          this.setState({
            choice3_no: 'accent-faliure',
          });
        }
      }
      let right_answer = 0;
      if (expectedCount === count) {
        right_answer = 1;
        this.setState({
          result: 'CORRECT',
          text_color: 'card-header text_success',
          result_block: 'card show_block',
        });
      } else {
        if (activateExplanation) {
          this.setState({
            result_block: 'card show_block',
            result: 'INCORRECT',
            text_color: 'card-header text_failure',
          });
        }
      }
      // --------------- Save Stat API call -----------//
      if (activateExplanation) {
        var data = {
          token: this.state.token,
          idname: this.state.idname,
          quiz_id: this.state.quiz_id,
          question_id: this.state.all_question_id[this.state.offset],
          answer: right_answer,
          reading_id: item.reading_id,
          type: 'tab_question',
        };
        FD.callAPI(App_data.backend_api + '/gmat_quizes/answerQuiz', data).then(resp => {
          if (resp.success) {
            var data = {
              token: this.state.token,
              idname: this.state.idname,
              question_id: this.state.questionId,
              right_answer: right_answer,
              type: 'tab_question',
              // time_done: this.state.count,
            };
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveStats', data).then(resp => {
              if (resp.success) {
              } else {
              }
            });
            this.setState({ ValidToken: true });
            this.setState({ validated: true });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        });
      }
    } else {
      // console.log('I am inside else ');
    }

    if (expectedCount === 3 || this.state.statement3 === '') {
      if (choice1 && choice2 && (choice3 || this.state.statement3 === '')) {
        this.setState({
          error: '',
        });
      } else {
        this.setRadioButtonBlank();
        this.setState({
          error: 'Please select all the options',
        });
      }
    } else if (expectedCount === 4) {
      if (choice1 && choice2 && choice3 && choice4) {
        this.setState({
          error: '',
        });
      } else {
        this.setRadioButtonBlank();
        this.setState({
          error: 'Required',
        });
      }
    } else if (expectedCount === 5) {
      if (choice1 && choice2 && choice3 && choice4 && choice5) {
        this.setState({
          error: '',
        });
        console.log('if5', expectedCount);
      } else {
        this.setRadioButtonBlank();
        this.setState({
          error: 'Please select all options',
        });
      }
    }
  };

  _getResultfor5Statements = async (item, e) => {
    let { answer1, answer2, answer3, answer4, answer5, userChoice } = this.state;
    const validateAnswer = (value, option) => {
      if (value) {
        this.setState({
          result: 'CORRECT',
          text_color: 'card-header text_success',
          result_block: 'card show_block',
          [`choice${option}_yes`]: 'accent-success',
        });
      } else {
        this.setState({
          result_block: 'card show_block',
          result: 'INCORRECT',
          text_color: 'card-header text_failure',
          [`choice${option}_yes`]: 'accent-faliure',
        });
      }
    };
    if (userChoice) {
      let right_answer = 0;
      if (answer1.toLocaleLowerCase().trim() === 'yes' && userChoice == 1) {
        right_answer = 1;
        validateAnswer(true, userChoice);
      } else if (answer2.toLocaleLowerCase().trim() === 'yes' && userChoice == 2) {
        right_answer = 1;
        validateAnswer(true, userChoice);
      } else if (answer3.toLocaleLowerCase().trim() === 'yes' && userChoice == 3) {
        right_answer = 1;
        validateAnswer(true, userChoice);
      } else if (answer4.toLocaleLowerCase().trim() === 'yes' && userChoice == 4) {
        right_answer = 1;
        validateAnswer(true, userChoice);
      } else if (answer5.toLocaleLowerCase().trim() === 'yes' && userChoice == 5) {
        right_answer = 1;
        validateAnswer(true, userChoice);
      } else {
        if (answer1.toLocaleLowerCase().trim() === 'yes')
          this.setState({ correct_answer_1: true }, () => this.setRadioButtonCorrectChoice(true));
        else if (answer2.toLocaleLowerCase().trim() === 'yes')
          this.setState({ correct_answer_2: true }, () => this.setRadioButtonCorrectChoice(true));
        else if (answer3.toLocaleLowerCase().trim() === 'yes')
          this.setState({ correct_answer_3: true }, () => this.setRadioButtonCorrectChoice(true));
        else if (answer4.toLocaleLowerCase().trim() === 'yes')
          this.setState({ correct_answer_4: true }, () => this.setRadioButtonCorrectChoice(true));
        else if (answer5.toLocaleLowerCase().trim() === 'yes')
          this.setState({ correct_answer_5: true }, () => this.setRadioButtonCorrectChoice(true));
        validateAnswer(false, userChoice);
      }
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        question_id: this.state.all_question_id[this.state.offset],
        answer: right_answer,
        reading_id: item.reading_id,
        type: 'tab_question',
      };
      FD.callAPI(App_data.backend_api + '/gmat_quizes/answerQuiz', data).then(resp => {
        if (resp.success) {
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: this.state.questionId,
            right_answer: right_answer,
            type: 'tab_question',
            // time_done: this.state.count,
          };
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveStats', data).then(resp => {
            if (resp.success) {
            } else {
            }
          });
          this.setState({ ValidToken: true });
          this.setState({ validated: true });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
  };
  /*
  ------------------------------------------------------------------------
     Function to Display Saved Question on button and save in database
  -------------------------------------------------------------------------
    */
  _saveQuestion = (item, e) => {
    console.log('item -------> ', this.state.reading, this.state.reading_id);
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.questionId,
      chapter_id: this.props.params.chapterid,
      type: 'tab_question',
      topic_name: this.state.reading,
      reading_id: this.props.params.readingid
        ? this.props.params.readingid
        : this.state.reading_id
          ? this.state.reading_id
          : 0,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      // return;
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
            bookmarkColor: '',
            save_text: `${language.LC().SAVE_QUESTION}`,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    } else {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
  };

  /*
  -------------------------------------
    Function to give star rattings
  -------------------------------------
    */
  onStarClick(item, nextValue, prevValue, name) {
    if (prevValue !== nextValue) {
      let params = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: item.id,
        ratting: nextValue,
      };
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/UpdateGMATRatting', params).then(
        response => {
          if (response.success) {
            this.setState({ rated: 1, ratting_text: 'Rated ' });
          }
        },
      );
    }

    this.setState({ rating: nextValue });
    let params = {
      token: this.state.token,
      question_id: item.id,
      idname: this.state.idname,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
      response => {
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: this.state.questionId,
          ratting: nextValue,
          type: 'tab_question',
        };
        if (response.success) {
          if (response.ratting.length > 0) {
            this.setState({ rated: true });
            response.ratting.map(items =>
              this.setState({ rating: items.ratting, ratting_text: 'Rated ' }),
            );
          } else {
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
              response => {
                if (response.success) {
                  this.setState({ rated: 1, ratting_text: 'Rated ' });
                }
              },
            );
          }
        } else {
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
            response => {
              if (response.success) {
                this.setState({
                  rated: 1,
                  ratting_text: `Rated ${nextValue} stars`,
                });
              }
            },
          );
        }
      },
    );
  }

  /*
  --------------------------------------
    Function to show Report box
  -------------------------------------
    */
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  /*
  -------------------------------------------
    Funcion to save new report question
  -------------------------------------------
    */
  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }
    console.log('itemit ---> ', e);
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.questionId,
      comment: comment,
      caseIndex: this.props.params.case_offset,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
      type: 'tab_question',
      topic_name: this.state.reading,
      reading_id: this.state.reading_id,
    };
    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/reportQuestion', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };
  removeRadioButtonClass = () => {
    this.setState({
      choice1_yes: '',
      choice2_yes: '',
      choice3_yes: '',
      choice4_yes: '',
      choice5_yes: '',
      choice1_no: '',
      choice2_no: '',
      choice3_no: '',
      choice4_no: '',
      choice5_no: '',
      correct_answer_1: '',
      correct_answer_2: '',
      correct_answer_3: '',
      correct_answer_4: '',
      correct_answer_5: '',
    });
  };
  //Function to fetch previous question
  _getPrevious = () => {
    this.setState({ display_loader: 'show_block' });
    this.setState({ validated: false });
    this.setState({
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      choice1: '',
      choice2: '',
      choice3: '',
      choice4: '',
      choice5: '',
      answer1: '',
      answer2: '',
      answer3: '',
      answer4: '',
      answer5: '',
    });
    this.setRadioButtonCorrectChoice(false);
    this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
    this.setState({ bookmarkColor: '' });
    this.setState({ save_text: `${language.LC().SAVE_QUESTION}` });
    this.setState({ report_block: 'card hide_block' });
    this.removeRadioButtonClass();
    document.getElementById('comment').value = '';
    if (this.state.error) {
      this.setState({
        error: '',
      });
    }
    // document.getElementById('ques_comment').value = '';

    var insert_time = {
      token: this.state.token,
      idname: this.state.idname,
      quiz_id: this.state.quiz_id,
      user_time_value: this.state.count,
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/insertTimer', insert_time).then(resp => {
      if (resp.success) {
        console.log('Timer Update Successfull');
      } else {
        console.log('Fail Timer Update');
      }
    });

    var index_id = this.state.offset - 1;
    if (this.state.question_length - 1 != index_id) {
      this.setState({ next_block: '' });
    }
    this.setState({ offset: index_id });
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.all_question_id[index_id],
      type: this.state.all_reading_type && this.state.all_reading_type[index_id],
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(resp => {
      if (resp.success) {
        const { questionsbyid } = resp;
        this.setQuestionData(resp.questionsbyid);
        this.setRadioButtonBlank();
        if (questionsbyid['gmat_reading.type'] === 'case_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_CASE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':case', questionsbyid.case_id)
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
          this.context.router.push({
            pathname: AppRoutes.GMAT_QUIZZES_BEGIN.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_GRAPH_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TABLE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TWOPART_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        }
        this.setState({ display_loader: 'hide_block' });
        var data_check = {
          token: this.state.token,
          idname: this.state.idname,
          quiz_id: this.state.quiz_id,
          question_id: this.state.all_question_id[this.state.offset],
          type: this.state.all_reading_type[this.state.offset],
        };
        FD.callAPI(App_data.backend_api + '/gmat_quizes/checkAnswered', data_check).then(resp => {
          this.setState({ already_answered_status: resp.message });
        });
        // this.setState({ choice_a: 'answer_box' });
        // this.setState({ choice_b: 'answer_box' });
        // this.setState({ choice_c: 'answer_box' });
        this.setState({ result_block: 'card hide_block' });
        this.setState({ display_question: resp.questionsbyid });

        var params = {
          token: this.state.token,
          question_id: this.state.all_question_id[this.state.offset],
          idname: this.state.idname,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params).then(
          response => {
            if (response.success) {
              this.setState({
                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              });
              this.setState({ save_text: `${language.LC().Question_Saved}` });
              this.setState({
                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              });
              this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
            }
          },
        );

        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 hide_block' });
                flash_cards = response.flash_cards.map(items => (
                  <li>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({ flash_form: 'col-sm-12 display_block' });
                flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-sm-12 display_block' });
            }
            return response;
          },
        );
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
          response => {
            var comments = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.comments.length > 0) {
                comments = response.comments.map(items => (
                  <li>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      {language.LC().BY} {items.username},{' '}
                      {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          },
        );
      } else {
        // console.log(resp.success + '------------failure');
      }
    });
    clearInterval(this.timer);
    if (!this.state.timer_stop) {
      this.timer = setInterval(this.tick.bind(this), 1000);
    }
  };
  componentWillUnmount() {
    clearInterval(this.timer);
    this.mounted = false;
  }
  //Function to fetch Next question
  _getNext = () => {
    this.setState({ display_loader: 'show_block' });
    this.setState({ validated: false });
    this.setState({
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      choice1: '',
      choice2: '',
      choice3: '',
      choice4: '',
      choice5: '',
      answer1: '',
      answer2: '',
      answer3: '',
      answer4: '',
      answer5: '',
    });
    this.setRadioButtonCorrectChoice(false);
    this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
    this.setState({ bookmarkColor: '' });
    this.setState({ save_text: `${language.LC().SAVE_QUESTION}` });
    this.setState({ report_block: 'card hide_block' });
    this.removeRadioButtonClass();
    document.getElementById('comment').value = '';
    if (this.state.error) {
      this.setState({
        error: '',
      });
    } else {
      console.log('else');
    }
    // document.getElementById('ques_comment').value = '';

    var insert_time = {
      token: this.state.token,
      idname: this.state.idname,
      quiz_id: this.state.quiz_id,
      user_time_value: this.state.count,
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/insertTimer', insert_time).then(resp => {
      if (resp.success) {
        //console.log('Timer Update Successfull');
      } else {
        //console.log('Fail Timer Update');
      }
    });
    var index_id = this.state.offset + 1;
    if (index_id > 0) {
      this.setState({ previ_block: '' });
    }
    if (this.state.question_length - 1 == index_id) {
      this.setState({ next_block: 'card hide_block' });
    }
    this.setState({ offset: index_id });
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.all_question_id[index_id],
      type: this.state.all_reading_type[index_id],
    };
    console.log('typeeee senddd', this.state.all_reading_type[index_id]);
    FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(resp => {
      const { questionsbyid } = resp;
      this.setQuestionData(resp.questionsbyid);
      this.setRadioButtonBlank();

      if (resp.success) {
        if (questionsbyid['gmat_reading.type'] === 'case_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_CASE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':case', questionsbyid.case_id)
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
          this.context.router.push({
            pathname: AppRoutes.GMAT_QUIZZES_BEGIN.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_GRAPH_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TABLE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TWOPART_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':timer', this.state.count),
          });
        }

        var data_check = {
          token: this.state.token,
          idname: this.state.idname,
          quiz_id: this.state.quiz_id,
          question_id: this.state.all_question_id[this.state.offset],
          type: this.state.all_reading_type[this.state.offset],
        };
        this.setState({ display_loader: 'hide_block' });
        //console.log(data_check);
        FD.callAPI(App_data.backend_api + '/gmat_quizes/checkAnswered', data_check).then(resp => {
          this.setState({ already_answered_status: resp.message });
        });
        // this.setState({ choice_a: 'answer_box' });
        // this.setState({ choice_b: 'answer_box' });
        // this.setState({ choice_c: 'answer_box' });
        this.setState({ result_block: 'card hide_block' });
        this.setState({ display_question: resp.questionsbyid });

        var params = {
          token: this.state.token,
          question_id: this.state.all_question_id[this.state.offset],
          idname: this.state.idname,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params).then(
          response => {
            if (response.success) {
              this.setState({
                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              });
              this.setState({ save_text: `${language.LC().Question_Saved}` });
              this.setState({
                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              });
              this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
            }
          },
        );

        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
                flash_cards = response.flash_cards.map(items => (
                  //alert(items.id)
                  <li>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({ flash_form: 'col-md-12 display_block' });
                flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-md-12 display_block' });
            }
            return response;
          },
        );

        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
          response => {
            var comments = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.comments.length > 0) {
                comments = response.comments.map(items => (
                  <li>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      {language.LC().BY} {items.username},{' '}
                      {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          },
        );
      } else {
        // console.log(resp.success + '------------failure');
      }
    });
    clearInterval(this.timer);
    if (!this.state.timer_stop) {
      this.timer = setInterval(this.tick.bind(this), 1000);
    }
  };
  setRadioButtonBlank = () => {
    for (let counter = 0; counter < 5; counter++) {
      let resetRadioButton = document.getElementsByName(`choice${counter + 1}`);
      for (var i = 0; i < resetRadioButton.length; i++) resetRadioButton[i].checked = false;
    }
  };
  setQuestionData = quesArr => {
    if (quesArr) {
      this.setState(
        {
          data: quesArr.question_tab,
          question: quesArr.question,
          statement1: quesArr.statement_A,
          statement2: quesArr.statement_B,
          statement3: quesArr.statement_C,
          statement4: quesArr.statement_D,
          statement5: quesArr.statement_E,
          questionId: quesArr.id,
          choice_a: quesArr.choice_a === '' ? 'Yes' : quesArr.choice_a,
          choice_b: quesArr.choice_b === '' ? 'No' : quesArr.choice_b,
          explanation: quesArr.explanation,
          questionHide: '',
          answer1: quesArr.answer_A,
          answer2: quesArr.answer_B,
          answer3: quesArr.answer_C,
          answer4: quesArr.answer_D,
          answer5: quesArr.answer_E,
          display_loader: 'hide_block',
          result_block: 'card hide_block',
          report_block: 'card hide_block',
          reading: quesArr['gmat_reading.reading'],
          reading_id: quesArr.reading_id,
        },
        () => {
          this.getFavQuestions(quesArr.id);
          this.getGMATRatting(quesArr.id);
        },
      );
    }
  };
  /*
  ---------------------------------
    Function to hide Report box
  ---------------------------------
  */
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };
  //Function to redirect page to readings page
  _getReadings = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_READING.replace(':id', this.props.params.chapterid),
    });
  };
  /*Function to start or stop timer*/
  _timer_funct = (item, e) => {
    // this.setState({timer_stop:!this.state.timer_stop});
    if (this.state.timer_stop) {
      this.setState({ timer_stop: false });
      /*this.setState({timer_tag:'Stop'});   */
      this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
      clearInterval(this.timer);
      this.timer = setInterval(this.tick.bind(this), 1000);
    } else {
      this.setState({ timer_stop: true });
      this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
      /*    this.setState({timer_tag:'Start'}); */
      clearInterval(this.timer);
    }
  };
  onChangeValue(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      [`${name}_yes`]: '',
      [`${name}_no`]: '',
    });
  }

  onChangeValueFor5Statement = (event, value) => {
    const { name } = event.target;
    this.removeRadioButtonClass();
    this.setRadioButtonCorrectChoice(false);
    this.setState({
      userChoice: value,
      [`${name}_yes`]: '',
      [`${name}_no`]: '',
    });
  };
  //Function to redirect page to readings beforestart
  _getSummary = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', this.state.quiz_id).replace(
        ':status_send',
        'abondon',
      ),
    });
  };
  //function to show calculator
  _handleModal = () => {
    this.setState({
      show: true,
    });
  };
  render() {
    const {
      statement1,
      statement2,
      statement3,
      statement4,
      statement5,
      choice_a,
      choice_b,
      question,
      explanation,
      reportLoading,
      offset,
      questionsArray,
      reading,
      display_loader,
      questionHide,
      choice1_yes,
      choice2_yes,
      choice3_yes,
      choice4_yes,
      choice5_yes,
      choice1_no,
      choice2_no,
      choice3_no,
      choice4_no,
      choice5_no,
      questionId,
      error,
      correct_answer_1,
      correct_answer_2,
      correct_answer_3,
      correct_answer_4,
      correct_answer_5,
    } = this.state;
    let questions = this.state.display_question;

    let count_temp_var = this.state.count;
    let display_time = '';
    if (count_temp_var < 60) {
      display_time = count_temp_var + 'sec';
    } else {
      var temp_min = Math.trunc(count_temp_var / 60);
      var temp_sec = Math.trunc(count_temp_var % 60);
      display_time = temp_min + 'min ' + temp_sec + 'sec';
    }
    return (
      <div>
        {/* ----------- Header ----------------- */}
        <div className='row'>
          <div className='col-sm-8 margin_bottom_20'>
            <h1 className='section_head'>
              {language.LC().QUIZ_ID} : {this.state.quiz_id}
            </h1>
            <h6 className='text-danger'>{this.state.already_answered_status}</h6>
          </div>
          <div className='col-sm-4 margin_bottom_20 text-sm-right'>
            <div>
              <button
                className='btn btn-primary pointer_class calc-btn'
                onClick={this._handleModal}
              >
                {' '}
                {language.LC().OPEN_CALCULATOR}
              </button>
              <button className='btn btn-primary pointer_class' onClick={this._getSummary}>
                {' '}
                {language.LC().BACK_TO_SUMMARY}{' '}
              </button>
            </div>
          </div>
        </div>
        <div className={`card margin_bottom_40 ${questionHide}`}>
          <div className='card-header'>
            <img
              src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
              className='margin_right_20'
              width='30'
              alt=''
            />
            {language.LC().Q} {parseInt(this.state.offset) + 1}{' '}
            {' '}
            <div className='float-right text-right'>
              {parseInt(offset) !== 0 ? (
                <i
                  className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block}
                  onClick={this._getPrevious}
                />
              ) : null}
              {questionsArray.length - 1 !== parseInt(offset) ? (
                <i
                  className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block}
                  onClick={this._getNext}
                />
              ) : null}
            </div>
          </div>
          <div className='row card-block'>
            <div
              className='col-lg-5 mb-0 overflow-y-auto mb-sm-1 calc_height_GMAT'
              style={{
                borderRadius: '0px',
                borderRight: '1px solid #f5f5f5',
              }}
            >
              {renderHTMLContent(
                this.state.data,
                "div",
                "",
                { onClick: this.clickHandler }
              )}
            </div>
            <div
              className='col-lg-5 mb-0 overflow-y-auto  mb-sm-1 font-16px calc_height_GMAT'
              style={{ borderRadius: '0px' }}
            >
              {renderHTMLContent(this.state.option, "div")}
              <form onSubmit={this.submit} className='m-15px'>
                {renderHTMLContent(question, "div")}
                <table className='m-15px'>
                  <tbody>
                    {statement1 && statement2 && statement3 && statement4 && statement5 ? (
                      <tbody className='first-letter-capitilize'>
                        <tr onChange={e => this.onChangeValueFor5Statement(e, 1)}>
                          <td className='pr-1'>
                            <input
                              type='radio'
                              id={correct_answer_1 ? 'correct_choice' : 'choice1'}
                              name={correct_answer_1 ? 'correct_choice' : 'choice1'}
                              // checked={correct_answer_1}
                              value='Yes'
                              className={
                                correct_answer_1
                                  ? `accent-success pointer_class`
                                  : `${choice1_yes}  pointer_class`
                              }
                            />
                          </td>
                          <td>{statement1}</td>
                        </tr>

                        <tr onChange={e => this.onChangeValueFor5Statement(e, 2)}>
                          <td>
                            <input
                              type='radio'
                              id={correct_answer_2 ? 'correct_choice' : 'choice1'}
                              name={correct_answer_2 ? 'correct_choice' : 'choice1'}
                              // checked={correct_answer_2}
                              value='Yes'
                              className={
                                correct_answer_2
                                  ? `accent-success pointer_class`
                                  : `${choice2_yes}  pointer_class`
                              }
                            />
                          </td>

                          <td>{statement2}</td>
                        </tr>

                        <tr onChange={e => this.onChangeValueFor5Statement(e, 3)}>
                          <td>
                            <input
                              type='radio'
                              id={correct_answer_3 ? 'correct_choice' : 'choice1'}
                              name={correct_answer_3 ? 'correct_choice' : 'choice1'}
                              // checked={correct_answer_3}
                              value='Yes'
                              className={
                                correct_answer_3
                                  ? `accent-success pointer_class`
                                  : `${choice3_yes}  pointer_class`
                              }
                            />
                          </td>
                          <td>{statement3}</td>
                        </tr>

                        <tr onChange={e => this.onChangeValueFor5Statement(e, 4)}>
                          <td>
                            <input
                              type='radio'
                              id={correct_answer_4 ? 'correct_choice' : 'choice1'}
                              name={correct_answer_4 ? 'correct_choice' : 'choice1'}
                              // checked={correct_answer_4}
                              value='Yes'
                              className={
                                correct_answer_4
                                  ? `accent-success pointer_class`
                                  : `${choice4_yes}  pointer_class`
                              }
                            />
                          </td>
                          <td>{statement4}</td>
                        </tr>

                        <tr onChange={e => this.onChangeValueFor5Statement(e, 5)}>
                          <td>
                            <input
                              type='radio'
                              id={correct_answer_5 ? 'correct_choice' : 'choice1'}
                              name={correct_answer_5 ? 'correct_choice' : 'choice1'}
                              // checked={correct_answer_5}
                              value='Yes'
                              className={
                                correct_answer_3
                                  ? `accent-success pointer_class`
                                  : `${choice5_yes}  pointer_class`
                              }
                            />
                          </td>
                          <td>{statement5}</td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody className='first-letter-capitilize'>
                        <tr>
                          <th>{choice_a}</th>
                          <th>{choice_b}</th>
                          <th />
                        </tr>
                        {statement1 ? (
                          <tr onChange={this.onChangeValue}>
                            <td>
                              <input
                                type='radio'
                                id='html'
                                name='choice1'
                                value='Yes'
                                className={`${choice1_yes}  pointer_class`}
                              />
                            </td>
                            <td>
                              <input
                                type='radio'
                                id='html'
                                name='choice1'
                                value='No'
                                className={`${choice1_no}  pointer_class`}
                              />
                            </td>
                            <td>{statement1}</td>
                          </tr>
                        ) : null}
                        {statement2 ? (
                          <tr onChange={this.onChangeValue}>
                            <td>
                              <input
                                type='radio'
                                id='html'
                                name='choice2'
                                value='Yes'
                                className={`${choice2_yes}  pointer_class`}
                              />
                            </td>
                            <td>
                              <input
                                type='radio'
                                id='html'
                                name='choice2'
                                value='No'
                                className={`${choice2_no}  pointer_class`}
                              />
                            </td>
                            <td>{statement2}</td>
                          </tr>
                        ) : null}

                        {statement3 ? (
                          <tr onChange={this.onChangeValue}>
                            <td>
                              <input
                                type='radio'
                                id='html'
                                name='choice3'
                                value='Yes'
                                className={`${choice3_yes}  pointer_class`}
                              />
                            </td>
                            <td>
                              <input
                                type='radio'
                                id='html'
                                name='choice3'
                                value='No'
                                className={`${choice3_no}  pointer_class`}
                              />
                            </td>
                            <td>{statement3}</td>
                          </tr>
                        ) : null}
                      </tbody>
                    )}
                  </tbody>
                </table>
                {/* ----------------- Validate and Rate Question */}
                <p className='error_msg'>{error}</p>
                <div className='d-flex'>
                  <ValidateSaveReportIcon
                    isQue={true}
                    // activateExplanation={activateExplanation}
                    _getResult={
                      statement1 && statement2 && statement3 && statement4 && statement5
                        ? this._getResultfor5Statements
                        : this._getResult
                    }
                    _saveQuestion={this._saveQuestion}
                    _displayReportForm={this._displayReportForm}
                    all_questions={question}
                    save_text={this.state.save_text}
                    bookmarkCSS={this.state.bookmarkCSS}
                    bookmarkColor={this.state.bookmarkColor}
                  // isSpecialQuestion={true}
                  />
                  {/* <div className='col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right'>
                    <div className='star_rating_wrap'>
                      <span className=' margin_bottom_0 margin_right_10'>
                        {this.state.ratting_text}
                      </span>
                      <StarRatings
                        rating={this.state.rating}
                        starRatedColor='rgb(255, 180, 0)'
                        starEmptyColor='rgb(51, 51, 51)'
                        starDimension='20px'
                        starHoverColor='rgb(255, 180, 0)'
                        starSpacing='2px'
                        changeRating={this.onStarClick.bind(this, question)}
                        numberOfStars={5}
                        name='rate1'
                      />
                    </div>
                  </div> */}
                </div>
                {/* ----------------- Explaination -------------*/}
                <div className={`${this.state.result_block}`}>
                  <div className={this.state.text_color}>{this.state.result}</div>
                  <div className='card-block font-16px'>
                    {renderHTMLContent(
                      explanation,
                      "p",
                      "view_questionhtml",
                      { contentEditable: 'false', suppressContentEditableWarning: true }
                    )}
                  </div>
                </div>
              </form>
            </div>
            {/* --------- Timer --------------- */}
            <div className='col-lg-2'>
              <div className='timer_outer'>
                <i className='fa fa-clock-o' />
                <span className='timer_box'>{display_time}</span>
              </div>
              <span className={'quiz_timer_btn ' + this.state.timer_display}>
                <button
                  type='button'
                  className={this.state.timerstopbtn}
                  onClick={this._timer_funct.bind(this, questions)}
                />
              </span>
              <p className='text-danger'>
                {renderHTMLContent(
                  this.state.count_end_message,
                  "div",
                  "",
                  { contentEditable: 'false' }
                )}
              </p>
            </div>
          </div>
        </div>
        {/* ---------- Report ----------- */}
        <div className={this.state.report_block}>
          <div className='card-header'>{language.LC().REPORT}</div>
          {!this.state.successAlert ? (
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-12'>
                  <label className='form-control-label' htmlFor='textarea-input'>
                    <strong> {language.LC().COMMENT}</strong>
                  </label>
                </div>
                <div className='col-sm-12 margin_bottom_10'>
                  <textarea
                    id='comment'
                    name='comment'
                    rows='6'
                    className='form-control'
                    placeholder='Content..'
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12'>
                  <button
                    type='button'
                    className='btn btn-primary active pointer_class report-btn'
                    disabled={reportLoading}
                    onClick={this._reportQuestion.bind(this, question)}
                  >
                    {' '}
                    {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                  </button>
                  <button
                    type='button'
                    className='btn btn-danger active pointer_class margin_left_10'
                    onClick={this._hideReportForm.bind(this, question)}
                  >
                    {' '}
                    {language.LC().CANCEL}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-12 report-Success-card'>
                  <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                  <label className='form-control-label' htmlFor='textarea-input'>
                    <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                  </label>
                  <button
                    type='button'
                    className='btn btn-primary active pointer_class  min-vw-120'
                    onClick={this.onClose}
                  >
                    {' '}
                    {language.LC().CLOSE}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* ---------- Loader ---------------- */}
        {display_loader === 'show_block' ? <Loader /> : null}
        <GMATCalculator
          addToInput={this.addToInput}
          show={this.state.show}
          addDecimal={this.addDecimal}
          addZeroToInput={this.addZeroToInput}
          clearInput={this.clearInput}
          add={this.add}
          subtract={this.subtract}
          multiply={this.multiply}
          divide={this.divide}
          evaluate={this.evaluate}
          closeModal={() => this.setState({ show: false })}
        />
      </div>
    );
  }
}
export default GMATTab;



// WEBPACK FOOTER //
// ./src/views/GMAT/Quizzes/BeginQuiz/BeginTabsQuiz.js